const getDisplayDBType = (dbType) => {
    switch (dbType) {
        case 'MARIADB':
            return 'MariaDB';
        case 'MSSQL':
            return 'MSSQL';
        case 'MYSQL':
            return 'MySQL';
        case 'ORACLE':
            return 'Oracle';
        case 'POSTGRESQL':
            return 'PostgreSQL';
        case 'SQLITE':
            return 'SQLite';
        default:
            return 'DB 타입';
    }
};

export default getDisplayDBType;
